export default __webpack_public_path__ + "static/media/milestone 1100.316c16e7.svg";